import CandidateForm from './CandidateForm';

export default CandidateForm;
